// Duplicate articles that were merged into a single canonical article.
// Two near-identical pages on the same topic split their own ranking signal in
// Google, so the weaker one is unpublished and its URL redirects permanently
// to the survivor.
export const MERGED_DISCOVERIES: Record<string, string> = {
  "ancient-giant-insects-oxygen-theory-jqgm": "ancient-giant-insects-oxygen-theory",
  // Two baby-grip articles split the same topic. The survivor sits in the
  // correct series (Inside Your Body) and has the fuller body.
  "newborn-monkey-grip-reflex": "babies-palmar-grasp-reflex",
  // Two cornea-breathes-air articles (same day, same fact). Survivor has the
  // fuller body.
  "human-cornea-direct-oxygen-air": "cornea-oxygen-bloodless-body-part",
};
